"use client";

// Coque COMMUNE des popups de ressources (Série, Fragments, Clés) de la capsule du
// haut. Un seul gabarit -> même cadre, même en-tête (icône + titre + badge), même
// style de bouton, pour que les trois forment une famille. Le corps (children)
// reste propre à chaque ressource.
//
// Règle de bouton : variant "upsell" = dégradé premium, RÉSERVÉ à la vraie
// conversion (ex. non-abonné "débloquer toutes les leçons"). Partout ailleurs,
// bouton plein de marque ("default"). Un popup sans action ne passe pas de cta.
import { Link } from "@/i18n/navigation";

export function ResourcePopupCTA({ href, label, variant = "default" }) {
    const styles =
        variant === "upsell"
            ? "bg-primary"
            : "bg-primary";
    return (
        <Link
            href={href}
            className={`mt-4 flex items-center justify-center rounded-full px-5 py-2.5 text-sm font-bold text-white hover:text-white transition-opacity hover:opacity-95 btn-3d lip-orange ${styles}`}
        >
            {label}
        </Link>
    );
}

export default function ResourcePopup({
    open,
    showTipsOnTop = false,
    icon,
    title,
    badge = null,
    width = "w-[360px]",
    children,
    cta = null,
}) {
    if (!open) return null;
    return (
        <div
            className={`absolute ${
                showTipsOnTop ? "bottom-12" : "top-full pt-3"
            } right-0 z-[100] animate-in fade-in slide-in-from-top-2 duration-200`}
        >
            {!showTipsOnTop && (
                <div className="absolute top-1 right-4 w-4 h-4 bg-white dark:bg-bgDark-840 border-l border-t border-gray-100 dark:border-borderDark transform rotate-45"></div>
            )}
            <div
                className={`relative bg-white dark:bg-bgDark-840 p-5 rounded-2xl shadow-xl shadow-black/10 dark:shadow-black/30 border border-gray-100 dark:border-borderDark cursor-auto ${width}`}
            >
                <div className="flex items-center justify-between gap-3">
                    <div className="flex min-w-0 items-center gap-2">
                        {icon}
                        <span className="truncate font-sourceSans text-lg font-bold text-[#06050F] dark:text-white">
                            {title}
                        </span>
                    </div>
                    {badge}
                </div>
                {children}
                {cta && <ResourcePopupCTA {...cta} />}
            </div>
        </div>
    );
}
